<template>
    <div class="layout-settings-color-picker">
        <div class="flex items-center gap-3 xl:gap-4">
            <span
                v-for="(color, index) in predefinedColors"
                :key="`color-${index}`"
                :style="{ backgroundColor: color }"
                :class="{'ring-2 ring-offset-2 ring-offset-main-bg ring-primary': localModel === color}"
                class="w-7 h-7 rounded-full cursor-pointer flex-shrink-0"
                @click="onSetPredefinedColor(color)"
            />
        </div>
        <div class="pt-6 flex items-center gap-3 lg:gap-4">
            <div>
                {{ `${$t('settings.customColor')}:` }}
            </div>
            <div class="flex items-center">
                <RedesignWidgetColor
                    v-model="localModel"
                    size="medium"
                    :predefined-colors="predefinedColors"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import { computed } from 'vue'
import { PREDEFINED_LAYOUT_COLORS } from '@/enum/colors'
import RedesignWidgetColor from '@/components/RedesignComponents/Widgets/Common/RedesignWidgetColor.vue'

const props = defineProps<{
    value?: string
    colorName?: string
}>()
const emit = defineEmits<{
    (e: 'input', value: string): void
    (e: 'update:value', value: string): void
}>()

const localModel = useVModel(props, 'value', emit, { eventName: 'input' })

const predefinedColors = computed(() => {
    return PREDEFINED_LAYOUT_COLORS[props.colorName || 'Default']
})

function onSetPredefinedColor (color: string) {
    localModel.value = color
}
</script>
